import { Stack, Typography } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'

export const ServiceKubernetesTargetingSelectionFooter: React.FC = () => (
  <Stack direction="row" sx={{ alignItems: 'center', gap: 1, pl: 2 }}>
    <Typography color="text.secondary">
      <Icon icon="solidCircleInfo" />
    </Typography>
    <Typography color="text.secondary" variant="caption">
      Gremlin supports targeting parent Kubernetes objects. Pods will be listed
      if they don't belong to a Set or Deployment
    </Typography>
  </Stack>
)
